const PageNotFound = () => {
    return <h2>Page not found!</h2>
}

export default PageNotFound;